import { PackageBundle } from "../../types/package.bundle";
import { generateAPI } from "../api.generator";

export const getAllPackageBundles = generateAPI<{}, PackageBundle[]>(
  "get",
  "package-bundle/all",
);
